(()=>{
'use strict';
const track=document.querySelector('.tl-track');if(!track)return;
const svg=track.querySelector('.tl-svg'),base=svg.querySelector('.tl-base'),prog=svg.querySelector('.tl-prog'),prog2=svg.querySelector('.tl-prog2'),head=svg.querySelector('.tl-head'),grad=svg.querySelector('#tlg');
const rail=document.querySelector('.tl-rail'),pill=document.querySelector('.tl-pill'),pillB=pill&&pill.querySelector('b');
const reduce=matchMedia('(prefers-reduced-motion: reduce)').matches;
const mss=[...track.querySelectorAll('.ms')],endDot=track.querySelector('.end-dot');
const dots=[...track.querySelectorAll('.ms-dot')];
let pts=[],L=0,H=0,W=0,counted=new Set(),lastCur=null;
const clamp=(v,a,b)=>Math.min(b,Math.max(a,v));
function build(){
  const tb=track.getBoundingClientRect();W=tb.width;H=tb.height;
  svg.setAttribute('viewBox',`0 0 ${W} ${H}`);svg.setAttribute('width',W);svg.setAttribute('height',H);
  grad.setAttribute('y2',H);
  pts=dots.map(d=>{const r=d.getBoundingClientRect();return {x:r.left-tb.left+r.width/2,y:r.top-tb.top+r.height/2}});
  if(!pts.length)return;
  const first=pts[0];let d=`M${first.x.toFixed(1)},0 L${first.x.toFixed(1)},${first.y.toFixed(1)}`;
  for(let i=0;i<pts.length-1;i++){
    const a=pts[i],b=pts[i+1],k=(b.y-a.y)*.55;
    d+=` C${a.x.toFixed(1)},${(a.y+k).toFixed(1)} ${b.x.toFixed(1)},${(b.y-k).toFixed(1)} ${b.x.toFixed(1)},${b.y.toFixed(1)}`;
  }
  base.setAttribute('d',d);prog.setAttribute('d',d);
  prog2.setAttribute('d',d);prog2.style.transform=`translateX(${W<760?9:16}px)`;
  L=prog.getTotalLength();
  [prog,prog2].forEach(p=>{p.style.strokeDasharray=L})
  update();
}
function lenAtY(y){
  let lo=0,hi=L;
  for(let i=0;i<16;i++){const m=(lo+hi)/2;if(prog.getPointAtLength(m).y<y)lo=m;else hi=m}
  return (lo+hi)/2;
}
function countUp(el){
  const y=+el.dataset.yr;if(reduce||!isFinite(y))return;
  const from=y-14,t0=performance.now(),dur=900;
  const step=t=>{const p=clamp((t-t0)/dur,0,1),e=1-Math.pow(1-p,3);el.textContent=Math.round(from+(y-from)*e);if(p<1)requestAnimationFrame(step);else el.textContent=y};
  el.textContent=from;requestAnimationFrame(step);
}
function update(){
  if(!L)return;
  const tb=track.getBoundingClientRect();
  const headY=reduce?H:clamp(innerHeight*.58-tb.top,0,H);
  const len=headY>=H?L:lenAtY(headY);
  prog.style.strokeDashoffset=L-len;
  prog2.style.strokeDashoffset=L-Math.max(0,len-L*.035);
  const hp=prog.getPointAtLength(len);
  head.setAttribute('cx',hp.x);head.setAttribute('cy',hp.y);
  head.style.opacity=(reduce||headY<=2||headY>=H-2)?0:1;
  let cur=null;
  mss.forEach((m,i)=>{
    const on=reduce||pts[i].y<=headY+6;
    m.classList.toggle('on',on);
    if(on){cur=m;const yr=m.querySelector('.ms-yr');if(yr&&!counted.has(m.id)){counted.add(m.id);countUp(yr)}}
  });
  if(endDot){const ey=pts[pts.length-1].y;endDot.classList.toggle('on',reduce||ey<=headY+6)}
  const inView=tb.top<innerHeight*.7&&tb.bottom>innerHeight*.35;
  const atEnd=endDot&&endDot.classList.contains('on');
  const label=atEnd?'Nu':(cur?cur.dataset.year:null);
  if(rail)rail.classList.toggle('show',inView);
  if(pill){pill.classList.toggle('show',inView&&!!label);if(label&&pillB)pillB.textContent=label}
  if(rail&&label!==lastCur){lastCur=label;rail.querySelectorAll('a').forEach(a=>a.classList.toggle('cur',a.dataset.rail===(atEnd?'vandaag':label)))}
}
let tick=false;
const onScroll=()=>{if(!tick){tick=true;requestAnimationFrame(()=>{tick=false;update()})}};
addEventListener('scroll',onScroll,{passive:true});
addEventListener('resize',build);
addEventListener('load',build);
if('ResizeObserver' in window)new ResizeObserver(()=>build()).observe(track);
if(rail)rail.addEventListener('click',e=>{
  const a=e.target.closest('a');if(!a)return;e.preventDefault();
  const t=document.querySelector(a.getAttribute('href'));if(t)t.scrollIntoView({behavior:reduce?'auto':'smooth',block:'center'});
});
build();
})();
